import {
  AutomationsPresentationV1,
  AutomationsPresentationV1Node
} from 'Automations/automationEditor'
import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'

export const getStartNode = (
  presentation: AutomationsPresentationV1,
  definitions: ResolvedNodeDefinitions
): AutomationsPresentationV1Node | undefined => {
  const startNode = presentation.nodes.find(node => {
    if (!node.type) throw new Error('Node is missing type')
    return !!definitions[node.type as NodeType]?.startNodeTriggerType
  })

  return startNode
}
